var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.588 12.4624C12.4617 12.3579 12.1522 12.0969 12.0259 11.9925C11.9607 11.7435 11.8956 11.3941 11.8548 10.9644C11.6186 8.59892 12.2703 6.81579 12.0055 6.72342C11.9526 6.70334 11.8426 6.75555 11.6023 7.12101V11.9764C11.6023 12.0929 11.6552 12.2053 11.7489 12.2816L16.2985 15.9242C16.323 15.9443 16.4167 16.0085 16.5511 16.0085C16.6855 16.0085 16.8484 15.884 16.8606 15.8639",
    fill: "#424D69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6935 4.9C13.5248 -0.00761008 5.02835 1.43014 2.58451 8.32971C-0.250351 16.5546 7.70843 24.6068 16.0704 21.1329C22.8317 18.2012 23.9559 9.7795 18.6935 4.89599V4.90402V4.9ZM12.144 21.0807C7.04045 21.3096 2.33198 17.2494 2.32383 12.1209C2.24644 4.13294 12.7061 -0.606001 18.6283 4.96828C24.5302 10.6389 20.2779 20.8076 12.144 21.0726V21.0807Z",
    fill: "#424D69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a399f664ffa0b4ea36022ebecccb20d1.svg";
export { ForwardRef as ReactComponent };